module.exports = __webpack_public_path__ + "static/media/facebook.79ee5931.png";